export function footer() {
  if (!$('#Footer .footer-logo').length) {
    const logoUrl = $('#imgLogo').attr('src');
    $('#MainFooter_FooterText').html('<img src="' + logoUrl + '" class="footer-logo">');
  }
}